export const isMainnet = process.env.NEXT_PUBLIC_IS_MAINNET === "true";
export const isLoggingEnabled = process.env.NEXT_PUBLIC_LOGGING === "true";
export const shouldLogErrors = process.env.NEXT_PUBLIC_LOG_ERRORS === "true";

export const WORMHOLE_EXECUTOR_QUOTE_BASE_URL = isMainnet
  ? "https://executor.labsapis.com"
  : "https://executor-testnet.labsapis.com";

export const wormholeExecutorQuoteUrl =
  process.env.NEXT_PUBLIC_WORMHOLE_EXECUTOR_QUOTE_URL ??
  WORMHOLE_EXECUTOR_QUOTE_BASE_URL;

const WORMHOLE_EXECUTOR_ONCHAIN_QUOTER_KEY_DEFAULT = isMainnet
  ? "0xa54008017941EcE968623a0Dd8Ee907E2b133596"
  : "0x5241C9276698439fEf2780DbaB76fEc90B633Fbd";

export const wormholeExecutorOnChainQuoterKey =
  process.env.NEXT_PUBLIC_WORMHOLE_EXECUTOR_ONCHAIN_QUOTER_KEY ??
  WORMHOLE_EXECUTOR_ONCHAIN_QUOTER_KEY_DEFAULT;
